import React, { useCallback, useEffect, useState } from "react"
import { Icon } from "../../atoms/icon";
import { themeDefault } from "../../layout/global-style"
import KeyboardEventHandler from 'react-keyboard-event-handler';
import { Button } from './styles';
import classNames from 'classnames';
export const HudButton = ({
  handleKeys,
  onClick,
  onHover,
  color = themeDefault.idlePrimary,
  hoverColor = themeDefault.hovered,
  disabledColor = themeDefault.disabled,
  fontColor = themeDefault.idlePrimary,
  fontHoverColor,
  fontDisabledColor = themeDefault.disabled,
  disabled,
  children,
  frame, revers, 
  ...props
}) => {
  const [hover, setHover] = useState(false);
  const handleHover = useCallback((isOver) => (e) => {
    const isHovered = !disabled && isOver;
    setHover(isHovered);
    if (onHover) onHover(isHovered, e);
  }, [disabled, onHover]);

  const handleClick = useCallback(e => {
    !disabled && onClick && onClick(e);
  }, [onClick, disabled])
  return (
    <Button
      color={disabled ? disabledColor : color}
      hoverColor={disabled ? disabledColor : hoverColor}
      fontColor={disabled ? fontDisabledColor : hover && fontHoverColor ? fontHoverColor : fontColor}
      disabled={disabled}
      onMouseEnter={handleHover(true)}
      onMouseLeave={handleHover(false)}
      onClick={handleClick}
      bgColor={'transparent'}
      className={classNames({ frame, revers })}
      {...props}
    >
      {children}
      {!handleKeys ? null : (
        <KeyboardEventHandler
          handleKeys={handleKeys}
          handleFocusableElements
          onKeyEvent={(key, e) => handleClick(e)}
        />)}
    </Button>
  )
}

export const HudIconButton = ({ icon, disabled, color = themeDefault.idlePrimary, ...props }) => {
  const [currentColor, setCurrentColor] = useState(disabled ? themeDefault.disabled : color);
  const onHover = useCallback((isOver, e) => {
    e.stopPropagation();
    const isHovered = !disabled && isOver;
    setCurrentColor(isHovered ? themeDefault.hovered : disabled ? themeDefault.disabled : color);
  }, [setCurrentColor, disabled, color])

  useEffect(() => {
    setCurrentColor(disabled ? themeDefault.disabled : color);
  }, [disabled, color])

  return (
    <HudButton onHover={onHover} disabled={disabled} color={color} {...props}>
      <Icon type={icon} color={currentColor} />
    </HudButton>
  )
}


HudButton.propTypes = Button.propTypes;

export default HudButton;
